class Dadata {
    constructor(params) {
        if (params.hasOwnProperty('apiKey')) {
            this.apiKey = params.apiKey;
        } else {
            console.log('Error: Dadata API key was not passed.');
            throw new Error('Error: Dadata API key was not passed.');
        }
    }
    
    _getRequestParams(query) {
        return {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + this.apiKey
            },
            body: JSON.stringify(query)
        };
    }
    
    async _getRequest(url, query) {
        const options = this._getRequestParams(query);
        const response = await fetch(url, options);
        return response.json();
    }
    
    // https://dadata.ru/api/geolocate/
    async getAddressByCoords(query) {
        const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/geolocate/address';
        return this._getRequest(url, query);
    }
    
    // https://dadata.ru/api/suggest/address/#request
    async getAddressByQuery(query) {
        const url = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';
        return this._getRequest(url, query);
    }
    
    static isValidLocationItem(item) {
        const isValid =
            // исключаем...
            item.data.city_district === null // ...районы городов
            && item.data.settlement_type_full !== 'территория'; // ...малозначимые населенные пункты
        
        return isValid;
    }
    
    static getFormattedLocationItem(item) {
        let nameParts = [];
        let regionParts = [];
        let nameShort = '';

        if (item.data.settlement || item.data.city) {
            let settlementName = '';
            let cityName = '';
            
            if (item.data.settlement) {
                nameShort = item.data.settlement;
                settlementName += `${item.data.settlement} ${item.data.settlement_type_full}`;
            }
            if (item.data.city) {
                cityName += item.data.city;
                if (item.data.city_type_full !== 'город') {
                    cityName += ' ' + item.data.city_type_full;
                }
                nameShort = item.data.city;
                
                // if (settlementName !== '') {
                //     settlementName += ' ' + item.data.settlement_type_full;
                // }
            }
    
            if (settlementName !== '') {
                nameParts.push(settlementName);
            }
            if (cityName !== '') {
                nameParts.push(cityName);
            }
        }

        if (item.data.area) {
            let partAreaName = '';
            partAreaName += item.data.area;
            if (item.data.area_type_full !== 'город') {
                partAreaName += ` ${item.data.area_type_full}`;
            }
            regionParts.push(partAreaName);
        }
    
        if (item.data.region) {
            let partRegionName = '';
            partRegionName += item.data.region;
            if (item.data.region_type_full !== 'город') {
                partRegionName += ` ${item.data.region_type_full}`;
            }
            regionParts.push(partRegionName);
        }
        
        return {
            id: item.data.kladr_id,
            name: nameParts.join(', '),
            nameParts: nameParts,
            nameShort: nameShort,
            region: regionParts.join(', '),
            regionParts: regionParts,
            
            original: item
        }
    }
}
